export const getRovoProductFromExtensionType = (extensionType: string): string | null => {
	const [product, moduleName] = extensionType.split(':');
	const SUPPORTED_PRODUCTS = ['jira', 'confluence', 'global'];

	// For xen:macro
	if (product === 'xen') {
		return 'confluence';
	}

	// Resolve non-portal JSM modules to Jira
	if (product === 'jiraServiceManagement') {
		if (moduleName && !moduleName.includes('portal')) {
			return 'jira';
		}
	}

	if (!SUPPORTED_PRODUCTS.includes(product)) {
		return null;
	}

	return product;
};
